import React, {FC} from "react";
import {Icon, Stack, Text} from "@fluentui/react";

const warningColor = "#ca5010";
const warningBackground = "#fff4ce";

interface IWorkOutsideWorkingHoursBadgeProps {
    compact?: boolean;
    style?: React.CSSProperties;
}

export const WorkOutsideWorkingHoursBadge: FC<IWorkOutsideWorkingHoursBadgeProps> = ({
                                                                                         compact,
                                                                                         style,
                                                                                     }) => (
    <Stack
        horizontal
        verticalAlign="center"
        tokens={{childrenGap: 4}}
        style={{
            alignSelf: "flex-start",
            background: warningBackground,
            border: `1px solid ${warningColor}`,
            borderRadius: 4,
            color: warningColor,
            fontWeight: 600,
            padding: compact ? "2px 6px" : "6px 8px",
            ...style,
        }}
    >
        <Icon iconName="Warning" styles={{root: {color: warningColor}}}/>
        <Text
            variant={compact ? "xSmall" : "small"}
            styles={{root: {color: warningColor, fontWeight: 600}}}
        >
            Rad izvan radnog vremena
        </Text>
    </Stack>
);
